import isEmpty from 'lodash/isEmpty';
import { fetchScoresByUser } from '../service/scores';

export const loadScores = userId => (dispatch, getState) => {
  let { jwToken, scores } = getState();

  if (!isEmpty(scores) && scores._id === userId) {
    return Promise.resolve(scores);
  }

  return fetchScoresByUser(jwToken, userId).then(res => {
    dispatch({ type: 'SCORES_SET', payload: res.data });
    return res.data;
  });
};
